import PropTypes from 'prop-types';

import { Box, FormHelperText } from '@mui/material';

import ScheduleRow from './ScheduleRow';

const ScheduleComponent = (props) => {
  const {
    input: { value, onChange },
    meta: { error, touched },
    getScheduleValues,
    getDisabledScheduleValues,
    isMultiTimeSlot,
    timezone,
    formErrors,
  } = props;

  if (!value) return null;

  const scheduleValues = getScheduleValues(
    value,
    onChange,
    getDisabledScheduleValues,
  );

  const hasError = touched && !!error;

  return (
    <Box>
      {hasError && (
        <Box mx="1.4rem">
          <FormHelperText error>{error}</FormHelperText>
        </Box>
      )}
      {scheduleValues?.map((day, i) => (
        <ScheduleRow
          key={day.checkbox.label + i}
          {...day}
          isMultiTimeSlot={isMultiTimeSlot}
          formErrors={formErrors}
        />
      ))}
      {/* TODO change label */}
      {timezone && <Box>&#42; {`Reservation times are in ${timezone}`}</Box>}
    </Box>
  );
};
ScheduleComponent.defaultProps = {
  isMultiTimeSlot: false,
  timezone: '',
};

ScheduleComponent.propTypes = {
  input: PropTypes.instanceOf(Object).isRequired,
  meta: PropTypes.instanceOf(Object).isRequired,
  formErrors: PropTypes.instanceOf(Object),
  getScheduleValues: PropTypes.func.isRequired,
  getDisabledScheduleValues: PropTypes.func.isRequired,
  isMultiTimeSlot: PropTypes.bool,
  timezone: PropTypes.string,
};

export default ScheduleComponent;
